import React, { ChangeEvent, useState } from 'react';
import SalesforceForm from '../SalesforceForm';
import SimpleButton from '../SimpleButton';
import FadeUp from '../animations/FadeUp';
import AnimatedDropdown from '../animations/AnimatedDropdown';

const occupationOptions = [
    "K-12 Student", "K-12 Teacher", "Higher Education Student", "Higher Education Instructor", "Industry", "Government", "Military", "Other"
];

const SignUpCyberRange: React.FC = () => {
    const [occupation, setOccupation] = useState('');
    const [otherOccupation, setOtherOccupation] = useState('');

    const handleOccupationChange = (e: ChangeEvent<HTMLSelectElement>) => {
        setOccupation(e.target.value);
    };

    const handleOtherOccupationChange = (e: ChangeEvent<HTMLInputElement>) => {
        setOtherOccupation(e.target.value);
    };

    const inputStyle = "p-4 rounded-xl border-none font-jarkarta bg-custom-black-shade text-white placeholder-white outline-none focus:ring-custom-blue";
    const inputFields = (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-4xl">
            <input
                type="text"
                placeholder="Full Name *"
                className={`${inputStyle} md:col-span-2`}
                name="name"
                required
                size={20}
            />
            <input
                type="text"
                placeholder="School or Organization *"
                className={`${inputStyle}`}
                name="00N8V00000MTd6Z"
                required
                size={20}
            />
            <input
                type="email"
                placeholder="Email *"
                className={`${inputStyle}`}
                name="email"
                required
                size={20}
            />
            <input
                type="tel"
                placeholder="Phone Number *"
                className={`${inputStyle}`}
                name="phone"
                required
                size={20}
            />
            <select
                name="00N8V00000OtOzH"
                className={`${inputStyle}`}
                value={occupation}
                onChange={handleOccupationChange}
                required
                hidden>

                <option value="" disabled>User Type *</option>
                <option value="K-12 Student">K-12 Student</option>
                <option value="K-12 Teacher">K-12 Teacher</option>
                <option value="Higher Education Student">Higher Education Student</option>
                <option value="Higher Education Instructor">Higher Education Instructor</option>
                <option value="Industry">Industry</option>
                <option value="Government">Government</option>
                <option value="Military">Military</option>
                <option value="Other">Other</option>
                {/* Add more options as needed */}
            </select>
            <AnimatedDropdown
                placeholder='User Type *'
                options={occupationOptions}
                selected={occupation}
                onSelect={setOccupation}
            />
            {occupation === "Other" && (  // Conditionally render free-type input field
                <input
                    type="text"
                    placeholder="Please specify *"
                    className={`${inputStyle}`}
                    value={otherOccupation}
                    onChange={handleOtherOccupationChange}
                    required
                />
            )}
        </div >
    );

    const button = (
        <SimpleButton
            size="large"
            label="Sign up now"
            textColor="text-white"
            bgColor="bg-gradient-[105deg] from-custom-blue from-40% to-custom-green to-130%"

            onClick={() => { }}
        />
    )


    return (
        <div id="Sign Up" className="bg-custom-black relative">
            <FadeUp>
                <div className="container mx-auto py-14 md:py-28 px-4 md:px-0 flex flex-col gap-10 md:gap-12 items-center">
                    <h1 className="text-4xl md:text-5xl font-bold text-center text-white font-jarkarta">Signup for the Heartland Cyber Range</h1>
                    <p className="text-base md:text-xl text-center text-white font-inter">
                        To receive more information and begin your journey towards a better tomorrow
                    </p>
                    <SalesforceForm
                        debug={false}
                        page="cyber_range_landing_signup"
                        children={inputFields}
                        button={button}
                        enableReCAPTCHA={false}
                        formStyle='flex flex-col justify-start md:justify-center items-center w-full gap-4'
                    />
                </div>
            </FadeUp>
        </div>
    );
};

export default SignUpCyberRange;


